import { useTranslation } from 'react-i18next'

import { Add } from '@mui/icons-material'
import { Box, Button, Chip, Fab, Grid, Tooltip } from '@mui/material'

import { useField, useFormikContext } from 'formik'

import PageHeading from 'components/atoms/PageHeading'

import { IAccommodationRow } from 'types'

import SelectField from 'components/atoms/fields/SelectField'
import { useGET_schoolSetupAccommodationsSelectQuery, useGET_accommodationCategoriesSelectQuery } from 'redux/api/setupApi'
import { FaTrashAlt } from 'react-icons/fa'
import { cloneDeep } from 'lodash'
import { useState } from 'react'

const AccommodationList = ({ fieldProps }) => {
  const { t } = useTranslation()
  const [field] = useField<IAccommodationRow[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const [clickStep, setClickStep] = useState(1)

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        category: null,
        items: [],
      },
    ])
  }

  const handleRemoveEntity = (index) => {
    const entities = cloneDeep(field.value)
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }



  return (
    <>
      {field?.value?.length > 0 ? (
          field?.value.map((value: IAccommodationRow, index: number) => (

                    <Grid container spacing={2} sx={{ paddingBottom: '10px !important' }} key={`accommodation_${index}`}>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                fieldProps={{
                                    label: t('common.accommodation'),
                                    name: `${fieldProps.name}[${index}]['category']`
                                }}
                                filters={{ is_enabled: true }}
                                apiCall={useGET_accommodationCategoriesSelectQuery}
                                hasHint={true}
                                onChange={() => setClickStep(clickStep+1)}
                            />
                        </Grid>
                        { value.category &&  <Grid item xs={12} md={5}>
                            <SelectField
                              fieldProps={{
                                label: t('common.accommodation-items'),
                                name: `${fieldProps.name}[${index}]['items']`
                              }}
                              multiple={true}
                              filters={{ page_size: 9999, categories: [value.category.id], clickStep: clickStep }}
                              apiCall={useGET_schoolSetupAccommodationsSelectQuery}
                              hasHint={true}
                            />
                        </Grid>
                        }
                        <Grid item xs={12} md={1}>
                            <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                                <Button
                                onClick={() => { 
                                    handleRemoveEntity(index) 
                                } }
                                aria-label='delete'
                                size='small'
                                color='error'
                                variant='outlined'
                                sx={{
                                    margin: '0',
                                    marginLeft: '10px',
                                    boxShadow: 'none',
                                    padding: '0.5rem 0.1rem',
                                    minWidth: '2.5rem !important',
                                    maxWidth: '2.5rem !important',
                                }}
                                >
                                <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>    
          ))
        ) : (
          <></>
        )}

       
          <Tooltip title={`${t('common.add')}`} arrow placement='top'>
            <Fab
              variant='extended'
              aria-label='add'
              size='small'
              onClick={handleAddEntity}
              color='success'
              sx={{ margin: '1rem 0 0.5rem auto', boxShadow: 'none' }}
            >
              <Add style={{ fontSize: '1.8rem' }} /> {t('common.add-accommodation')}
            </Fab>
          </Tooltip>
    </>
  )
}

export default AccommodationList
